
class CapSubmitUserManagement {
  constructor(config) {
    this.config = config
  }
  
  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'submit_user_management'
}

function create(config) {
  return new CapSubmitUserManagement(config)
}

export default {
  key,
  create,
}
